export const lcvParticipantsConstants = {
    LCV_PARTICIPANTS_GET_JOB_ROLES_REQUEST:"LCV_PARTICIPANTS_GET_JOB_ROLES_REQUEST",
    LCV_PARTICIPANTS_GET_JOB_ROLES_COMPLETE:"LCV_PARTICIPANTS_GET_JOB_ROLES_COMPLETE",

    LCV_PARTICIPANTS_IMPORT_REQUEST:"LCV_PARTICIPANTS_IMPORT_REQUEST",
    LCV_PARTICIPANTS_IMPORT_COMPLETE:"LCV_PARTICIPANTS_IMPORT_COMPLETE",

    LCV_PARTICIPANTS_CLEAR_IMPORT_RESULT:"LCV_PARTICIPANTS_CLEAR_IMPORT_RESULT",

    LCV_PARTICIPANTS_GET_IMPORT_HISTORY_REQUEST:"LCV_PARTICIPANTS_GET_IMPORT_HISTORY_REQUEST",
    LCV_PARTICIPANTS_GET_IMPORT_HISTORY_COMPLETE:"LCV_PARTICIPANTS_GET_IMPORT_HISTORY_COMPLETE",
};
